import { createContext } from "react";
/**
 * Available to all components. Provided by `openmrsComponentDecorator`.
 */ export const ComponentContext = createContext({
    moduleName: '',
    featureName: ''
});
